import { FormView, FormViewType } from '@shared/models/form-view.model';
import { LABELS } from './labels.constant';

export const DATE_MAINT_COLUMNS: FormView[] = [
  { field: 'startDate', header: LABELS.START_DATE, type: 'date', sortable: true },
  { field: 'endDate', header: LABELS.END_DATE, type: 'date', showDivider: true, sortable: true, isEndDate: true, isRequired: false},
];

export const DATE_MAINT_COLUMNS_TPL: FormView[] = [
  { field: 'startDate', header: LABELS.START_DATE, type: 'template', sortable: true },
  { field: 'endDate', header: LABELS.END_DATE, type: 'template', showDivider: true, sortable: true, isEndDate: true },
];


export const BASE_MAINT_COLUMNS: FormView[] = [
  { field: 'description', header: LABELS.DESCRIPTION, type: 'string', sortable: true },
  { field: 'frequency', header: LABELS.FREQUENCY, type: 'enum', sortable: true },
  { field: 'adjustmentBeforeTaxable', header: LABELS.ADJUSTMENT_BEFORE_TAXABLE, type: 'toggle', sortable: true, isRequired: false },

  ...DATE_MAINT_COLUMNS
];

export const BASE_MAINT_COLUMNS_TPL: FormView[] = [
  { field: 'description', header: LABELS.DESCRIPTION, type: 'template', sortable: true },
  { field: 'frequency', header: LABELS.FREQUENCY, type: 'template', sortable: true },
  { field: 'adjustmentBeforeTaxable', header: LABELS.ADJUSTMENT_BEFORE_TAXABLE, type: 'template', sortable: true, isRequired: false },
  ...DATE_MAINT_COLUMNS
];


export const BASE_MAINT_COLUMNS_NO_ADJUSTMENT: FormView[] = [
  { field: 'description', header: LABELS.DESCRIPTION, type: 'string', sortable: true },
  { field: 'frequency', header: LABELS.FREQUENCY, type: 'enum', sortable: true },
  ...DATE_MAINT_COLUMNS
];

export const BASE_MAINT_COLUMNS_NO_ADJUSTMENT_FREQ: FormView[] = [
  { field: 'description', header: LABELS.DESCRIPTION, type: 'string', sortable: true },
  ...DATE_MAINT_COLUMNS
];

export const SALARY_COLUMNS: FormView[] = [
  { field: 'minimumMonthlySalary', header: LABELS.MINIMUM_MONTHLY_SALARY, type: 'number', sortable: true },
  { field: 'maximumMonthlySalary', header: LABELS.MAXIMUM_MONTHLY_SALARY, type: 'number', sortable: true },
];

export const TAXABLE_SALARY_COLUMNS: FormView[] = [
  { field: 'minimumTaxableSalary', header: LABELS.MINIMUM_TAXABLE_SALARY, type: 'number', sortable: true },
  { field: 'maximumTaxableSalary', header: LABELS.MAXIMUM_TAXABLE_SALARY, type: 'number', sortable: true },
];

export const EMPLOYEE_SHARE_COLUMNS: FormView[] = [
  { field: 'employeeShare', header: LABELS.EMPLOYEE_SHARE, type: 'number', sortable: true },
  { field: 'employerShare', header: LABELS.EMPLOYER_SHARE, type: 'number', sortable: true },
];

export const EMPLOYEE_SHARE_PERCENT_COLUMNS: FormView[] = [
  { field: 'employeeShare', header: LABELS.EMPLOYEE_SHARE, type: 'percentage', sortable: true },
  { field: 'employerShare', header: LABELS.EMPLOYER_SHARE, type: 'percentage', sortable: true },
];

export const SHARE_COLUMNS = (module: string, type?: FormViewType): FormView[] => {
  return [
    { field: `${module}EmployeeShare`, header: LABELS.EMPLOYEE_SHARE, type: type || 'number', sortable: true },
    { field: `${module}EmployerShare`, header: LABELS.EMPLOYER_SHARE, type: type || 'number', sortable: true }
  ]
};

export const CODE_DESC_COLUMNS: FormView[] = [
  { header: LABELS.CODE, field: 'code', type: 'string', sortable: true },
  { header: LABELS.DESCRIPTION, field: 'description', type: 'string', sortable: true },
];

export const DETAILS_FREQ_ADJUSTMENT_COLUMNS: FormView[] = [
  { field: 'details.frequency', header: LABELS.FREQUENCY, type: 'enum', sortable: true },
  { field: 'details.adjustmentBeforeTaxable', header: LABELS.ADJUSTMENT_BEFORE_TAXABLE, type: 'toggle', sortable: true, isRequired: false },

];

export const DETAILS_DATE_MAINT_COLUMNS: FormView[] = [
  { field: 'details.startDate', header: LABELS.START_DATE, type: 'date', sortable: true },
  { field: 'details.endDate', header: LABELS.END_DATE, type: 'date', showDivider: true, sortable: true, isEndDate: true },
];
